<template>
    <div class="cmp-wrapper">
      <basic-container>
        <h2>账单详情</h2>
        <p>当前状态: {{formData.statusStr}}</p>
        <div class="button-container">
        <el-button type="text"  @click="handleBillRecord()">流水明细</el-button>
      </div>
        <br/>
        <div>
          <el-card class="box-card" style="margin: 10px">
            <el-row 
              type="flex"
              :gutter="20"
              style="margin-bottom:20px"
            >
              <el-col :span="8">
                <div class="grid-content">
                  <p>账单号: {{formData.id}}</p>
                  <p>账单类型: {{formData.billTypeStr}}</p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content">
                  <p>分账主体ID: {{formData.accountId}}</p>
                  <p>结算单日期: {{formData.billPeriod}}</p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content">
                  <p>分账主体名称: {{formData.accountName}}</p>
                  <p>账单发起日期: {{formData.createDateStr}}</p>
                </div>
              </el-col>
            </el-row>
          </el-card>
        </div>
        <br/>
        <div>
          <el-card class="box-card" style="margin: 10px">
            <h2 class="title">平台应付</h2>
            <el-row class="row-bg">
              <el-col :span="8" align="center">
                <span style="font-weight: bold">款项</span>
              </el-col>
              <el-col :span="8" align="center">
                <span style="font-weight: bold">金额</span>
              </el-col>
              <el-col :span="8" align="center">
                <span style="font-weight: bold">备注</span>
              </el-col>
            </el-row>
            <el-row class="row-bg">
              <el-col :span="8" align="center">代收服务费</el-col>
              <el-col :span="8" align="center">{{(formData.accountServerAmount - formData.decreaseAccountServerAmount).toFixed(2)}}元</el-col>
              <el-col :span="8" align="center">(正向-逆向)</el-col>
            </el-row>
          </el-card>
        </div>
        <br/>
        <div>
          <el-card class="box-card" style="margin: 10px">
            <h2 class="title">平台应收</h2>
            <el-row class="row-bg">
              <el-col :span="8" align="center">
                <span style="font-weight: bold">款项</span>
              </el-col>
              <el-col :span="8" align="center">
                <span style="font-weight: bold">金额</span>
              </el-col>
              <el-col :span="8" align="center">
                <span style="font-weight: bold">备注</span>
              </el-col>
            </el-row>
            <el-row class="row-bg">
              <el-col :span="8" align="center">平台服务费</el-col>
              <el-col :span="8" align="center">{{(formData.platformPointAmount - formData.decreasePlatformPointAmount).toFixed(2)}}元</el-col>
              <el-col :span="8" align="center">(正向-逆向)</el-col>
            </el-row>
          </el-card>
        </div>
        <br/>
        <div class="divider"></div>
        <div>
          <el-card class="box-card" style="margin: 10px">
            <h2 class="title">结算汇总</h2>
            <el-row>
              <el-col :span="12" align="center">
                <p>平台应收</p>
                <br />
                <p style="color: red; font-size: 20px">{{formData.receiveAmount}}元</p>
              </el-col>
              <el-col :span="12" align="center">
                <p>平台应付</p>
                <br />
                <p style="color: red; font-size: 20px">{{formData.sendAmount}}元</p>
              </el-col>
            </el-row>
          </el-card>
        </div>
        <br/>

        <div class="divider"></div>
        <div>
          <el-card class="box-card" style="margin: 10px">
            <template #header>
              <div class="card-header">
                应付金额: <span style="font-size: 30px; color: #fece0e"> {{(formData.sendAmount - formData.receiveAmount).toFixed(2)}}元</span>
                <br />
                抵扣欠款:
                <span style="font-size: 30px; color: #fece0e"
                  >{{formData.debtAmount}}元</span
                >
                <br />
                实付金额: <span style="font-size: 30px; color: red">{{formData.requireAmount}}元</span>
              </div>
            </template>
          </el-card>
        </div>
        <div class="divider"></div>
        <div class="footer" v-if="formData.status===3">
          <el-button type="warning" @click="handleDisagree">我有异议</el-button>
          <el-button type="success" @click="handleAgree">确认无误</el-button>
        </div>
        <div>
          <el-dialog
            title="意见描述"
            :visible.sync="showDisagreeDialog"
            width="50%"
          >
            <el-input v-model="reviewDesc" :style="{ height: '40px' }" placeholder="请输入描述"></el-input>
            <div slot="footer" class="dialog-footer">
              <el-button @click="showDisagreeDialog = false">取消</el-button>
              <el-button type="primary" @click="submitBillReview">确定</el-button>
            </div>
          </el-dialog>
        </div>
        
      </basic-container>
    </div>
  </template>
  
  <script>
  
  export default {
    data() {
      return {
        formData: {
          id: "",
          accountId: "",
          accountName: "",
          startTime: "",
          endTime: "",
          receiveAmount: "",
          sendAmount: "",
          requireAmount: "",
          debtAmount: "",
          createUserName: "",
          createTime: "",
          compileTime: "",
          paymentList: [],
          billTypeStr: 1,
          billPeriod: "",
          createDateStr: "",
          compileTimeStr: "",
          statusStr: "",
          accountServerAmount: "",
          decreaseAccountServerAmount: "",
          platformPointAmount: "",
          decreasePlatformPointAmount: ""
        },
        reviewDesc:"",
        tableData: [],
        billId: "",
        showDisagreeDialog: false

      };
    },
  
    created() {
      this.billId=this.$route.query.billId;
      this.getbillDetail();
    },

    beforeRouteEnter(to, from, next) {
      next(async vm => {
        try {
          vm.billId = vm.$route.query.billId;
          vm.getbillDetail();
        } catch (error) {
          console.log(error);
          next();
        }
        
      })
    },

    methods: {
      handleBack() {
        this.$router.go(-1);
      },

      handleBillRecord() {
        this.$router.push({
          path: "/splitAccountManage/billRecord",
          query: {
            billId: this.$route.query.billId,
            subjectId: this.formData.accountId,
          },
        });
      },

      async getbillDetail(){
        const{
          ret,
          data
        } = await _api.splitAcc.getBillDetail({
          billId:this.$route.query.billId
        });

        if(ret && data) {
          this.formData = data;
        }
      },

      handleAgree(){
        this.agree();
      },

      handleDisagree(){
        this.showDisagreeDialog=true;
      },

      submitBillReview(){
        this.disagree();
      },

      async agree(){
        const{
          ret,
          data
        } = await _api.splitAcc.billReview({
          billId: this.billId,
          isPass: true,
          desc: ""
        });
        if(ret && data){
          this.$message({
          type: "success",
          message: "提交成功"
        });
        }
        this.getbillDetail();
      },

      async disagree(){
        const{
          ret,
          data
        } = await _api.splitAcc.billReview({
          billId: this.billId,
          isPass: false,
          desc: this.reviewDesc
        });
        if(ret && data){
          this.$message({
            type: "success",
            message: "提交成功"
          });
        }
        this.showDisagreeDialog=false;
        this.getbillDetail();
      }
      
    }
  };
  </script>
  <style scoped>
  .el-input {
    width: 300px;
  }
  .el-textarea {
    width: 400px;
  }
  .el-select {
    width: 130px;
  }
  .title {
    font-weight: 900;
    font-size: 16px;
  }
  .multiline-text {
    white-space: pre-line;
  }
  .show-money {
    color: red;
    font-size: 16px;
  }
  .divider {
    width: 100%;
    height: 1px;
    background-color: #dec33d;
    margin: 10px 0; /* 可根据需要调整上下间距 */
  }
  .button-container {
  position: absolute;
  top: 30px;
  right: 20px;
}
  </style>
  